/*==========================================================
CONTRAST MODE SCRIPT
==========================================================*/
var contrastMode = false;

function toast() {
    var x = document.getElementById('toastContrast');
    x.classList.add('show');
    setTimeout(function() {
        x.classList.remove('show');
    }, 2000);
}

$(function() {
    $('.contrastSwitcher').on('click', function(event) {
        event.preventDefault();
        $(this).blur();

        if (contrastMode) {
            $('html').removeClass('contrast-mode');
            contrastMode = false;

            toast();
        } else {
            $('html').addClass('contrast-mode');
            contrastMode = true;

            toast();
        }
    });
});
